import React from "react";
import { Link } from "react-router-dom";

export default function CTA({ variant = "site" }) {
  const isHome = variant === "home";

  return (
    <div
      className={`p-16 bg-secondary rounded-[32px] flex flex-col gap-8 items-start bg-textureCTA bg-no-repeat bg-center max-w-7xl mx-4`}
      id="contact"
    >
      <div className="flex flex-col gap-4">
        <h3 className="text-main font-bold text-3xl">
          {isHome
            ? "Vous perdez du temps sur des tâches répétitives ?"
            : "Mettez votre offre en avant"}
        </h3>
        <p className="text-main font-normal max-w-[614px]">
          {isHome
            ? "Chaque heure passée sur de l'administratif est une heure en moins pour développer votre activité. Je mets en place des automations sur-mesure qui travaillent pour vous, 24h/24."
            : "Présentez votre offre avec un site moderne et distinguez vous de la concurrence. Nous mettons à votre disposition une équipe sur-mesure pour un résultat unique."}
        </p>
      </div>
      <Link
        to="https://wa.me/message/4QESRNQVOAAXK1"
        target="_blank"
        className="bg-yellow text-secondary rounded-full py-2 px-4 font-semibold text-base"
      >
        {isHome ? "Discutons de vos besoins →" : "Me contacter →"}
      </Link>
    </div>
  );
}
